/* JUGO ACV PDP — concatenated inline scripts from pdp-final-8/index-gallery.html */

/* ===== script #1 ===== */
(function () {
    var section = document.querySelector('.lj1');
    var track   = document.querySelector('[data-lj1-track]');
    if (!section || !track) return;

    // ===== Scroll-driven parallax (matches the homepage social carousel UX) =====
    // The carousel drifts horizontally as the page scrolls, BUT only when the
    // user is NOT actively touching it. While a finger is down we bail out
    // entirely so native horizontal swipe AND vertical page scroll stay
    // perfectly smooth — no scroll-snap, no touch-action lock fighting the
    // gesture (see CSS). Nudges are DELTA-based (never an absolute reset), so
    // the carousel keeps wherever the user last left it.
    var lastScrollY = window.scrollY;
    var touchActive = false;
    var inViewport  = false;

    track.addEventListener('touchstart',  function () { touchActive = true;  }, { passive: true });
    track.addEventListener('touchend',    function () { touchActive = false; }, { passive: true });
    track.addEventListener('touchcancel', function () { touchActive = false; }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inViewport = e.isIntersecting;
          if (inViewport) lastScrollY = window.scrollY;
        });
      }, { threshold: 0 }).observe(section);
    } else {
      inViewport = true;
    }

    window.addEventListener('scroll', function () {
      if (touchActive || !inViewport) { lastScrollY = window.scrollY; return; }
      var dy = window.scrollY - lastScrollY;
      lastScrollY = window.scrollY;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      var speed = window.innerWidth < 768 ? 0.3 : 0.6;
      track.scrollLeft = Math.max(0, Math.min(track.scrollLeft + dy * speed, max));
    }, { passive: true });

    // ===== Chevron buttons =====
    document.querySelectorAll('[data-lj1-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-lj1-dir'), 10) || 1;
        var tile = track.querySelector('.lj1__tile');
        var step = tile ? tile.getBoundingClientRect().width + 16 : 320;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });

    // ===== Video play/pause toggle =====
    document.querySelectorAll('.lj1__play').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video');
        if (!v) return;
        if (v.paused) v.play(); else v.pause();
      });
    });
  })();

/* ===== script #2 ===== */
(function () {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var els = document.querySelectorAll('[data-reveal]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  })();

/* ===== script #3 ===== */
(() => {
  const main = document.querySelector('[data-gallery]');
  if (!main) return;
  const hero = document.querySelector('.hero');
  const slides = main.querySelectorAll('.hero-gallery__slide');
  const thumbs = document.querySelectorAll('.hero-gallery__thumb');
  let idx = 0;
  let engaged = false;
  const total = slides.length;

  function engage() {
    if (engaged || !hero) return;
    engaged = true;
    hero.classList.add('hero--gallery-engaged');
  }

  function go(n) {
    idx = (n + total) % total;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    engage();
    // Reposition arrows + thumbs to hug the new image's actual bounds.
    requestAnimationFrame(positionControls);
  }

  // ===== Image-aware control positioning =====
  // CSS positions arrows / thumbs at fixed offsets, but slide images have
  // varied aspect ratios so the actual rendered image bounds (object-fit
  // contain) sit at different places per slide. JS measures the active
  // image and snaps arrows / thumbs to its real edges.
  const stage = document.querySelector('.hero-stage');
  const prevArrow = stage && stage.querySelector('.hero-gallery__arrow--prev');
  const nextArrow = stage && stage.querySelector('.hero-gallery__arrow--next');
  const thumbsRow = stage && stage.querySelector('.hero-gallery__thumbs');

  function parsePos(v, def) {
    if (!v) return def;
    if (v.endsWith('%')) return parseFloat(v) / 100;
    if (v === 'left' || v === 'top') return 0;
    if (v === 'right' || v === 'bottom') return 1;
    if (v === 'center') return 0.5;
    return def;
  }

  function getImageBounds(img) {
    if (!img.complete || !img.naturalWidth) return null;
    const rect = img.getBoundingClientRect();
    const cs = getComputedStyle(img);
    const padT = parseFloat(cs.paddingTop) || 0;
    const padR = parseFloat(cs.paddingRight) || 0;
    const padB = parseFloat(cs.paddingBottom) || 0;
    const padL = parseFloat(cs.paddingLeft) || 0;
    const padW = rect.width - padL - padR;
    const padH = rect.height - padT - padB;
    if (padW <= 0 || padH <= 0) return null;

    const naturalRatio = img.naturalWidth / img.naturalHeight;
    const containerRatio = padW / padH;

    let actualW, actualH;
    if (naturalRatio > containerRatio) {
      actualW = padW;
      actualH = padW / naturalRatio;
    } else {
      actualH = padH;
      actualW = padH * naturalRatio;
    }

    const op = (cs.objectPosition || '50% 50%').split(/\s+/);
    const opX = parsePos(op[0], 0.5);
    const opY = parsePos(op[1], 0.5);

    const x = rect.left + padL + (padW - actualW) * opX;
    const y = rect.top + padT + (padH - actualH) * opY;
    return { x: x, y: y, w: actualW, h: actualH };
  }

  function positionControls() {
    if (!stage) return;
    // JS-driven positioning is desktop-only — mobile uses pure CSS rules
    // (see @media max-width:760px in jugo-pdp-acv.css.liquid). Detect via
    // the desktop-only sticky stage to avoid overriding mobile defaults.
    if (getComputedStyle(stage).position !== 'sticky') {
      ['prev','next'].forEach(k => {
        const el = k === 'prev' ? prevArrow : nextArrow;
        if (el) { el.style.left = ''; el.style.right = ''; el.style.top = ''; el.style.transform = ''; }
      });
      if (thumbsRow) { thumbsRow.style.left = ''; thumbsRow.style.right = ''; thumbsRow.style.top = ''; thumbsRow.style.bottom = ''; thumbsRow.style.transform = ''; }
      return;
    }
    const activeSlide = stage.querySelector('.hero-gallery__slide.is-active');
    if (!activeSlide) return;
    if (!activeSlide.complete || !activeSlide.naturalWidth) {
      activeSlide.addEventListener('load', positionControls, { once: true });
      return;
    }
    const bounds = getImageBounds(activeSlide);
    if (!bounds) return;

    const stageRect = stage.getBoundingClientRect();
    const buyboxEdgeRaw = getComputedStyle(stage).getPropertyValue('--buybox-edge') || '489px';
    const buyboxEdge = parseFloat(buyboxEdgeRaw) || 489;
    const visibleRight = Math.max(0, stageRect.width - buyboxEdge);

    // Full image bounds (stage-relative). For the bleed slide, imgRight
    // extends past visibleRight; otherwise the image is contained inside
    // the visible portion.
    const imgLeft = bounds.x - stageRect.left;
    const imgTop = bounds.y - stageRect.top;
    const imgRight = imgLeft + bounds.w;
    const imgBottom = imgTop + bounds.h;
    const imgCenterY = imgTop + bounds.h / 2;

    // Visible portion of the image = image cropped by the visible area
    // (what the user actually sees, excluding what's hidden under the
    // buybox or clipped by stage edges). Arrows + thumbs anchor to THIS
    // so they stay centered with the visible image instead of drifting
    // toward the bleed area or away from a portrait-image's centerline.
    const visImgLeft = Math.max(0, imgLeft);
    const visImgRight = Math.min(visibleRight, imgRight);
    const visImgCenterX = (visImgLeft + visImgRight) / 2;

    const arrowSize = (prevArrow && prevArrow.offsetWidth) || 44;
    const arrowGap = 12;
    const arrowTop = imgCenterY - arrowSize / 2;
    const arrowHalf = arrowSize / 2;

    // Position arrows + thumbs against the visible image content.
    //
    // next arrow: hugs the image's right edge, clamped to visible right.
    // thumbs: centred under the image content, clamped to the visible area.
    //
    // prev arrow has two modes:
    //   * Slide 1 startup (bleed): the image bleeds past both edges of
    //     the visible area, so a mirror across the image element centre
    //     lands ON the bottle composition at narrower viewports. Instead
    //     place prev in the cream margin to the LEFT of the composition.
    //     Composition-cutout has its content starting at 29.3% horizontal
    //     of the source image; after applying the bleed transform that
    //     becomes  stage_w * 0.2445 - 102.84  in stage coords.
    //   * Everything else (slides 2-6, slide 1 after engagement): mirror
    //     across the image content centre so prev hugs the image's left
    //     edge symmetrically with next.
    const edgeGap = 8;
    const imageRight = imgLeft + bounds.w;
    const anchorX = imgLeft + bounds.w / 2;
    const isBleedStart = activeSlide.hasAttribute('data-bleed-default')
                      && hero && !hero.classList.contains('hero--gallery-engaged');

    const nextCxIdeal = imageRight + arrowGap + arrowHalf;
    const nextCxMax = visibleRight - edgeGap - arrowHalf;
    const nextCx = Math.min(nextCxIdeal, nextCxMax);

    const prevCxMin = edgeGap + arrowHalf;
    let prevCx;
    if (isBleedStart) {
      // Composition's left edge in stage_x (post-transform). Place prev
      // just inside that edge so the chevron sits in the cream margin.
      const compositionLeft = stageRect.width * 0.2445 - 102.84;
      prevCx = Math.max(compositionLeft - arrowGap - arrowHalf, prevCxMin);
    } else {
      const prevCxRaw = 2 * anchorX - nextCx;
      prevCx = Math.max(prevCxRaw, prevCxMin);
    }

    if (prevArrow) {
      prevArrow.style.left = (prevCx - arrowHalf) + 'px';
      prevArrow.style.right = 'auto';
      prevArrow.style.top = arrowTop + 'px';
      prevArrow.style.transform = 'none';
    }
    if (nextArrow) {
      nextArrow.style.left = (nextCx - arrowHalf) + 'px';
      nextArrow.style.right = 'auto';
      nextArrow.style.top = arrowTop + 'px';
      nextArrow.style.transform = 'none';
    }
    if (thumbsRow) {
      const thumbsHalfW = thumbsRow.offsetWidth / 2;
      const thumbsMin = thumbsHalfW + edgeGap;
      const thumbsMax = Math.max(thumbsMin, visibleRight - thumbsHalfW - edgeGap);
      const thumbsX = Math.max(thumbsMin, Math.min(thumbsMax, anchorX));
      thumbsRow.style.left = thumbsX + 'px';
      thumbsRow.style.right = 'auto';
      thumbsRow.style.top = 'auto';
      thumbsRow.style.bottom = '16px';
      thumbsRow.style.transform = 'translateX(-50%)';
    }
  }

  // Initial + reactive positioning
  slides.forEach(s => s.addEventListener('load', positionControls));
  window.addEventListener('resize', () => requestAnimationFrame(positionControls));
  if (window.ResizeObserver && stage) {
    new ResizeObserver(() => requestAnimationFrame(positionControls)).observe(stage);
  }
  // First paint: wait a tick for layout to settle
  requestAnimationFrame(() => requestAnimationFrame(positionControls));

  document.querySelectorAll('[data-gallery-dir]').forEach(btn => {
    btn.addEventListener('click', () => {
      const dir = parseInt(btn.getAttribute('data-gallery-dir'), 10) || 1;
      go(idx + dir);
    });
  });
  thumbs.forEach(t => {
    t.addEventListener('click', () => go(parseInt(t.getAttribute('data-gallery-go'), 10) || 0));
  });

  // Touch swipe
  let startX = 0, startY = 0, tracking = false;
  main.addEventListener('touchstart', e => {
    if (!e.touches[0]) return;
    startX = e.touches[0].clientX; startY = e.touches[0].clientY; tracking = true;
  }, { passive: true });
  main.addEventListener('touchend', e => {
    if (!tracking || !e.changedTouches[0]) return;
    tracking = false;
    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      go(idx + (dx < 0 ? 1 : -1));
    }
  });

  // Mouse drag (desktop swipe-feel)
  let mDown = false, mX = 0;
  main.addEventListener('mousedown', e => { mDown = true; mX = e.clientX; });
  window.addEventListener('mouseup', e => {
    if (!mDown) return;
    const dx = e.clientX - mX;
    mDown = false;
    if (Math.abs(dx) > 60) go(idx + (dx < 0 ? 1 : -1));
  });

  // Keyboard
  document.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft') go(idx - 1);
    if (e.key === 'ArrowRight') go(idx + 1);
  });
})();

/* ===== script #4 ===== */
(() => {
  const root = document.querySelector('.price-card');
  if (!root) return;
  const purchaseOpts = root.querySelectorAll('.purchase-opt');
  const bottleOpts   = root.querySelectorAll('.bottle-opt');
  const cartBtn      = root.querySelector('.btn-cart');
  const cartPriceEl  = root.querySelector('[data-bottle-price]');
  const supplyEl     = root.querySelector('[data-bottle-supply]');
  function currentMode() {
    const r = root.querySelector('input[name="purchase-mode"]:checked');
    return r ? r.value : 'sub';
  }
  function priceFor(input, mode) {
    return (mode === 'onetime' ? input.dataset.priceOnetime : input.dataset.priceSub) || '';
  }
  function saveFor(input, mode) {
    return (mode === 'onetime' ? input.dataset.saveOnetime : input.dataset.saveSub) || '';
  }
  function fmtPrice(p, mode) {
    return mode === 'sub' ? (p + '<small>/4wks</small>') : p;
  }
  function syncBottle() {
    const mode = currentMode();
    const sel = root.querySelector('input[name="bottles"]:checked');
    // Re-price every bundle card for the current mode (sub vs one-time).
    bottleOpts.forEach(opt => {
      const r = opt.querySelector('input[name="bottles"]');
      if (!r) return;
      opt.classList.toggle('is-selected', r.checked);
      const priceEl = opt.querySelector('.bottle-opt__price');
      const saveEl  = opt.querySelector('.bottle-opt__save');
      if (priceEl) priceEl.innerHTML = fmtPrice(priceFor(r, mode), mode);
      if (saveEl) {
        const sv = saveFor(r, mode);
        saveEl.textContent = sv;
        saveEl.style.display = sv ? '' : 'none';
      }
      // discount-% badge (2 & 4 bottles) — swaps between subscribe and one-time
      const badgeEl = opt.querySelector('.bottle-opt__badge');
      if (badgeEl) {
        const bv = (mode === 'onetime' ? r.dataset.badgeOnetime : r.dataset.badgeSub) || '';
        badgeEl.textContent = bv;
        badgeEl.style.display = bv ? '' : 'none';
      }
    });
    // Mirror the selected bundle's price onto the Add-to-cart button.
    if (sel) {
      if (cartPriceEl) cartPriceEl.innerHTML = fmtPrice(priceFor(sel, mode), mode);
      if (supplyEl && sel.dataset.supply) supplyEl.innerHTML = sel.dataset.supply + ' at 1/day';
    }
  }
  function syncMode() {
    purchaseOpts.forEach(opt => {
      const r = opt.querySelector('input[type="radio"]');
      opt.classList.toggle('is-selected', r && r.checked);
    });
    syncBottle();
  }
  root.querySelectorAll('input[name="purchase-mode"]').forEach(r => r.addEventListener('change', syncMode));
  root.querySelectorAll('input[name="bottles"]').forEach(r => r.addEventListener('change', syncBottle));
  syncMode();

  if (cartBtn) {
    cartBtn.addEventListener('click', () => {
      cartBtn.animate(
        [{ transform: 'translateY(0)' }, { transform: 'translateY(-3px)' }, { transform: 'translateY(0)' }],
        { duration: 250, easing: 'cubic-bezier(.34, 1.56, .64, 1)' }
      );
    });
  }
})();

/* ===== script #5 — Cart form sync (quantity + selling_plan; single source of truth) =====
   The theme renders its own Subscribe / One-time UI and drives a single hidden
   [data-selling-plan-input]. The Appstle Subscriptions app, however, injects its
   OWN name="selling_plan" radios into this product form and defaults the subscribe
   option to checked. If those injected fields are left alone they post alongside
   ours, so choosing "One-time" still adds a 4-week subscription to the cart.
   Fix: the theme's hidden input is the ONLY selling_plan field allowed to post —
   every other one (Appstle's) gets its name stripped so it is never submitted. */
(function () {
  var form = document.querySelector('[data-cart-form]');
  if (!form) return;
  var quantityInput = form.querySelector('[data-cart-quantity]');
  var planInput     = form.querySelector('[data-selling-plan-input]');

  var mo = null;

  function syncQuantity() {
    var sel = document.querySelector('input[name="bottles"]:checked');
    if (sel && sel.value && quantityInput) quantityInput.value = sel.value;
  }

  function desiredPlanId() {
    var mode = document.querySelector('input[name="purchase-mode"]:checked');
    // The radio's data-selling-plan carries the plan ID (empty for one-time).
    return mode ? (mode.dataset.sellingPlan || '') : '';
  }

  function syncPlan() {
    var planId = desiredPlanId();

    // The Appstle Subscriptions app injects its OWN name="selling_plan" radios
    // into this form and intercepts /cart/add based on which radio is checked,
    // defaulting to Subscribe. Its choice overrides the plain form field, so the
    // theme's Subscribe / One-time selection MUST be mirrored onto Appstle's
    // radios — otherwise One-time silently adds a 4-week subscription. Detach the
    // observer while we drive them so Appstle's re-render doesn't recurse on us.
    if (mo) mo.disconnect();
    var appstleRadios = document.querySelectorAll('[id^="appstle_selling_plan_label_"]');
    appstleRadios.forEach(function (r) {
      var match = (r.value || '') === planId;
      if (r.checked !== match) {
        r.checked = match;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Keep the theme's own hidden field consistent (single plain form field +
    // fallback if Appstle ever fails to load).
    if (planInput) {
      if (planId) { planInput.setAttribute('name', 'selling_plan'); planInput.value = planId; }
      else { planInput.removeAttribute('name'); planInput.value = ''; }
    }
    if (mo) mo.observe(form, { childList: true, subtree: true });
  }

  document.querySelectorAll('input[name="bottles"]').forEach(function (r) {
    r.addEventListener('change', syncQuantity);
  });
  document.querySelectorAll('input[name="purchase-mode"]').forEach(function (r) {
    r.addEventListener('change', syncPlan);
  });

  // Appstle injects its widget asynchronously after load — re-mirror our choice
  // onto its radios whenever it (re)renders. The change-guard above means this
  // settles after Appstle's markup matches the theme state.
  if (window.MutationObserver) {
    mo = new MutationObserver(function () { syncPlan(); });
    mo.observe(form, { childList: true, subtree: true });
  }

  // Initial sync (also corrects Appstle if it injected before this ran).
  syncQuantity();
  syncPlan();

  // Definitive enforcement at submit, regardless of injection timing.
  form.addEventListener('submit', function () {
    syncQuantity();
    syncPlan();
  });
})();
